import {
    IDataArray,
    DataArray,
    Company,
    Minesite,
    Permission,
	SectionPermission,
	UserCompany
} from '../index';


export class FMIPubType implements IDataArray {
    public Id = 0;
    public Name: string;

 //   public Company: Company = null;
 //   public Minesite: Minesite = null;
 //   public Permission: Permission = new Permission();
	//public Sections: DataArray<SectionPermission> = new DataArray<SectionPermission>();
	//public AssignedCompanies: Company[] = [];
	//public Companies: UserCompany[] = [];

	//public IsSpecial(): boolean {
	//	return this.AssignedCompanies.length !== 0;
	//}

    public GetById(): number {
        return this.Id;
    }
}
